import {authorize, Overlay} from "@athena-portal/components";
import * as React from "react";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import {ImgTileLink} from "../../../../components/ImgTileLink";
import {Link, RouteComponentProps} from "react-router-dom";
import {SuccessfulPurchaseModal} from "../../../../components/modals/SuccessfulPurchaseModal";
import {
    ANNUAL_HOME_RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL,
    AnnualPolicyPremiumTypeEnum,
    CLAIM_TYPE_OTHER,
    FalconNavigatorHeader,
    ICustomerPortalService,
    InstalmentsInfo,
    INTERACTION_PROCESS_CHANGE_ADDRESS,
    INTERACTION_PROCESS_MTA,
    INTERACTION_PROCESS_MTC_LV,
    INTERACTION_PROCESS_NB,
    INTERACTION_PROCESS_RENEWAL,
    Policy,
    POLICY_STATUS_MTC,
    POLICY_STATUS_PENDING_RENEWAL,
    POLICY_STATUS_UNDERWRITING_FAILURE,
    PolicyProperty,
    PolicyPropertyEnum,
    ProductsEnum,
    Renewal,
    resourcesHelper,
    Types,
} from "@falcon/services";
import {lazyInject} from "@athena-portal/core";
import {finalize} from "rxjs/operators";
import {NextYearAutoRenewalBanner} from "../../../../components/banners/NextYearAutoRenewalBanner";
import {RenewNextYearConfirmationModal} from "../../../../components/modals/RenewNextYearConfirmationModal";
import {BackButton} from "../../../../components/navigation/BackButton";
import {AnnualProductPaymentMessageBanner} from "../../../../components/banners/AnnualProductPaymentMessageBanner";
import * as moment from "moment/moment";
import {
    ChangeAddressStorageSuccessModal
} from "../../../../components/modals/annual/home/ChangeAddressStorageSuccessModal";
import {MtaStorageSuccessModal} from "../../../../components/modals/annual/home/MtaStorageSuccessModal";
import {NoActivePolicyBanner} from "../../../../components/banners/NoActivePolicyBanner";
import {OverdueInstalmentBanner} from "../../../../components/banners/OverdueInstalmentBanner";
import {OutstandingPaymentBanner} from "../../../../components/banners/OutstandingPaymentBanner";
import {formatDateTime, getProductByPolicyNumber, setSessionStorage} from "../../../../CommonFunctions";
import {SportsVoucherBanner} from "../../../../components/banners/SportsVoucherBanner";
import {LVDataLayerHelper} from "../../../../utils/LVDataLayerHelper";
import {DashcamBanner} from "../../../../components/banners/DashcamBanner";
import {AutoRenewalInviteBanner} from "../../../../components/banners/AutoRenewalInviteBanner";
import {PolicyWillBeRenewedBanner} from "../../../../components/banners/PolicyWillBeRenewedBanner";
import {AnnualHomeManualRenewalModal} from "../../../../components/modals/AnnualHomeManualRenewalModal";
import {AnnualHomeManualRenewalConfirmation} from "../../../../components/modals/AnnualHomeManualRenewalConfirmation";
import {RenewalDeclinedBanner} from "../../../../components/banners/RenewalDeclinedBanner";
import {StorageSuccessModal} from "../../../../components/modals/StorageSuccessModal";
import {
    GracePeriodRenewalStorageSuccessModal
} from "../../../../components/modals/annual/home/GracePeriodRenewalStorageSuccessModal";
import {SportsPassBanner} from "../../../../components/banners/SportsPassBanner";
import {pushToAdobeDataLayerDelayed} from "../../../../utils/AdobeDataLayerHelper";
import {GracePeriodBanner} from "../../../../components/banners/GracePeriodBanner";
import {AllianzAdvantagesBanner} from "../../../../components/banners/AllianzAdvantagesBanner";
import {UnpaidChangeBanner} from "../../../../components/banners/UnpaidChangeBanner";

interface IDashboardParams {
    policyNumber: string;
}

interface IProps extends RouteComponentProps<IDashboardParams> {
    location: any;
}

interface IState {
    policy?: Policy;
    policyPropertiesLoaded: boolean;
    renewNextYear?: boolean;
    apiCalled: boolean;
    showRenewalSwitchConfirmation: boolean;
    instalmentsInfo?: InstalmentsInfo;
    missedPaymentInfo?: InstalmentsInfo,
    instalmentInfoLoaded: boolean;
    hasExpiredPolicies?: boolean;
    hasOldPolicies?: boolean;
    renewalProposal?: Renewal;
    automaticRenewal?: boolean;
    showManualRenewalConfirmation: boolean;
    manualRenewalPopUpIsShown: boolean;
    showEditRenewalSuccessPopup: boolean;
    bannerShownLocally: boolean;
    bannerShownInSession:boolean;
    reuseCard: boolean;
    hasOldMotorPolicies?: boolean;
}

@authorize
export class AnnualHomeDashboardPage extends React.Component<IProps, IState> {

    private multiPolicyAccount: boolean;

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;
    private product: ProductsEnum;
    private pushToAdobeDataLayerTimeout: any;

    constructor(props: IProps) {
        super(props);

        this.state = {
            policyPropertiesLoaded: false,
            apiCalled: false,
            showRenewalSwitchConfirmation: false,
            instalmentsInfo: {} as InstalmentsInfo,
            instalmentInfoLoaded: false,
            showManualRenewalConfirmation: false,
            manualRenewalPopUpIsShown: window.sessionStorage.getItem("manualRenewalPopUpIsShown") === "true",
            showEditRenewalSuccessPopup: window.sessionStorage.getItem("showRenewalEditSuccessPopup") === "true",
            bannerShownLocally: window.localStorage.getItem("bannerCalledLocally" + this.props.match.params.policyNumber) === "true",
            bannerShownInSession: window.sessionStorage.getItem("bannerCalledInSession" + this.props.match.params.policyNumber) === "true",
            reuseCard: false
        }

        this.multiPolicyAccount = window.sessionStorage.getItem("multiPolicyAccount") === "true";

        this.displayReviewDialog();

        this.turnOnNextYearRenewal = this.turnOnNextYearRenewal.bind(this);
        this.setAutomaticRenewal = this.setAutomaticRenewal.bind(this);
        this.setPerformRenewal = this.setPerformRenewal.bind(this);
        this.turnOnManualNextYearRenewal = this.turnOnManualNextYearRenewal.bind(this);
        this.hideManualRenewalConfirmation = this.hideManualRenewalConfirmation.bind(this);
        this.product = getProductByPolicyNumber(this.props.match.params.policyNumber)
    }

    public componentDidMount(): void {
        const policyNumber: string = this.props.match.params.policyNumber;

        this.customerPortalService.getPolicies(this.product, undefined, true)
            .subscribe((activePolicies: Policy[]) => {

                this.customerPortalService.getExpiredPolicies()
                    .subscribe(expiredPolicies => {
                        this.setState({
                            hasExpiredPolicies: Boolean(expiredPolicies && expiredPolicies.length > 0),
                            hasOldMotorPolicies: this.filterByProduct(expiredPolicies, ProductsEnum.WOLF_MOTOR).length > 0
                        });
                        const policies = [...(activePolicies || []), ...(this.filterByProduct(expiredPolicies, this.product) || [])];
                        const filteredPolicy: Policy = policies
                            .filter((policy: Policy) => policy.products.includes(this.product) && policy.policyNumber === this.props.match.params.policyNumber)[0];

                        if (filteredPolicy) {
                            this.setState({
                                policy: filteredPolicy
                            });

                            const agreementVersionIds: number[] = filteredPolicy.policyHistoryList
                                .filter(ph => ph.status !== POLICY_STATUS_MTC)
                                .map(ph => ph.id);

                            this.customerPortalService.getCombinedInstalmentsInfo(agreementVersionIds).subscribe((instalmentsInfo: any) => {
                                this.setState({instalmentsInfo, instalmentInfoLoaded: true});
                            });

                            if (filteredPolicy.interaction?.factors?.premiumType === AnnualPolicyPremiumTypeEnum.ANNUAL &&
                                filteredPolicy.interaction?.renewalDetails?.policyAgeYears > 0) {
                                this.customerPortalService.getMissedPaymentInfo(filteredPolicy.interaction.agreementVersionId)
                                    .subscribe(
                                        (missedPaymentInfo: InstalmentsInfo) => {
                                            this.setState({missedPaymentInfo});
                                        });
                            }
                        }
                    });

            })

        this.customerPortalService.getRenewalProposal(policyNumber).subscribe((renewalProposal: Renewal) => {
            this.setState({renewalProposal})
        })

        this.customerPortalService
            .getPolicyPropertiesByPropertyKeys(policyNumber, [PolicyPropertyEnum.PERFORM_RENEWAL, PolicyPropertyEnum.POLICY_DEBT, PolicyPropertyEnum.REUSE_MAIN_CARD])
            .pipe(finalize(() => this.setState({policyPropertiesLoaded: true})))
            .subscribe((properties: PolicyProperty[]) => {
                    properties.forEach(property => {
                        if (property.key === PolicyPropertyEnum.AUTOMATIC_RENEWAL) {
                            this.setState({automaticRenewal: property.value === 'true'});
                        } else if (property.key === PolicyPropertyEnum.PERFORM_RENEWAL) {
                            this.setState({renewNextYear: property.value === "true"})
                        } else if (property.key === PolicyPropertyEnum.REUSE_MAIN_CARD) {
                            this.setState({reuseCard: property.value === 'true'})
                        }
                    })
                }
            );

        this.customerPortalService.getPolicyHistoryAfterRenewal().subscribe((policyHistories: Policy[]) => {
            this.setState({
                hasOldPolicies: Boolean(policyHistories && policyHistories.length > 0)
            });
        });
        window.sessionStorage.setItem("fromDashboard", "true");
        this.pushToAdobeDataLayerTimeout = pushToAdobeDataLayerDelayed(2000);
    }

    componentWillUnmount() {
        clearTimeout(this.pushToAdobeDataLayerTimeout);
    }

    public render(): React.ReactNode {
        const policy: Policy = this.state.policy!;
        const referrerJourney: string | null = window.sessionStorage.getItem("referrerJourney");
        const showSuccessPopup: string | null = window.sessionStorage.getItem("showPopup");
        const policyHolder: any = policy?.policyHolder;
        const interaction: any = policy?.interaction;
        const monthly: boolean = interaction?.factors?.premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY;
        const futureCancelledPolicyBeforeInception: boolean = policy != null && moment.utc(policy.endDate, moment.ISO_8601).isSame(moment.utc(policy.startDate, moment.ISO_8601))
            && moment.utc(policy.startDate, moment.ISO_8601).isAfter(moment(), 'day');
        const hasPendingRenewal: boolean = this.state.renewalProposal != null && this.state.renewalProposal.status === POLICY_STATUS_PENDING_RENEWAL;

        if (policyHolder && this.state.policyPropertiesLoaded) {
            const inGracePeriod: boolean = policy.annualPolicyInfo != null ? policy.annualPolicyInfo.inGracePeriod : false;

            // Recreate DataLayer
            new LVDataLayerHelper().mapInteractionToDataLayer(interaction);

            return (
                <>
                    <Overlay show={this.state.apiCalled}/>
                    {this.state.showEditRenewalSuccessPopup && this.renderRenewalEditSuccessModal()}
                    {hasPendingRenewal
                        && !this.state.manualRenewalPopUpIsShown
                        && !this.state.automaticRenewal
                        && (!this.state.renewNextYear || inGracePeriod)
                        && <AnnualHomeManualRenewalModal
                        currentPolicy={policy}
                        renewalProposal={this.state.renewalProposal!}
                        turnOnNextYearRenewal={this.turnOnManualNextYearRenewal}/>}
                    {this.state.showManualRenewalConfirmation && <AnnualHomeManualRenewalConfirmation
                        currentPolicy={policy}
                        renewalProposal={this.state.renewalProposal!}
                        hideManualRenewalConfirmation={this.hideManualRenewalConfirmation}/>}
                    {referrerJourney === INTERACTION_PROCESS_NB && showSuccessPopup &&
                        <SuccessfulPurchaseModal headerText={monthly ? "Deposit payment complete" : "Payment complete"}
                                                 modalContent={this.renderSuccessPopup()}/>
                    }
                    {this.renderMtaSuccessPopups(referrerJourney, showSuccessPopup, interaction, hasPendingRenewal, policy)}
                    {this.state.showRenewalSwitchConfirmation && <RenewNextYearConfirmationModal/>}
                    <FalconHeader/>
                    <div className="page-contents dashboard-page pt-3">
                        <FalconNavigatorHeader
                            back={{
                                link: "/dashboard",
                                hidden: !this.multiPolicyAccount
                            }}
                            title={this.multiPolicyAccount ? 'Home policy' : `Hi ${policyHolder.firstName}`}
                        />

                        {this.renderBanners(futureCancelledPolicyBeforeInception)}
                        {this.renderLinkGrid(futureCancelledPolicyBeforeInception)}
                        {this.multiPolicyAccount && <BackButton isTop={false} link={"/dashboard"}/>}
                    </div>
                    <FalconFooter/>
                </>
            )
        } else {
            return <Overlay show={true}/>
        }
    }

    private renderRenewalEditSuccessModal(): React.ReactNode {
        return <StorageSuccessModal
            title={"All done"}
            explanationWording={"All the changes made to your renewal policy are saved."}
            explanationWordingStyles={"font-weight-bold"}
            passFontAndLineStyles={"font-and-line-styles"}
            onClose={this.renewalEditSuccessModalOnClose}
        />
    }

    private renewalEditSuccessModalOnClose(): void {
        window.sessionStorage.setItem("showRenewalEditSuccessPopup", "false")
        this.setState({
            showEditRenewalSuccessPopup: false
        })
    }

    // @ts-ignore
    private renderBanners(futureCancelledPolicyBeforeInception: boolean): React.JSX.Element {
        const policy: Policy = this.state.policy!;
        const interaction = policy?.interaction;
        const annualPolicyInfo = policy.annualPolicyInfo;
        const showOverdueInstalmentsBanner: boolean | undefined = annualPolicyInfo?.hasDebt && annualPolicyInfo.overdueMonthlyInvoiceAmount != null
            && +annualPolicyInfo.overdueMonthlyInvoiceAmount > 0;
        const outstandingPaid: string | null = window.sessionStorage.getItem("outstandingPaid");
        const hasActivePolicy: boolean = moment.utc(policy.endDate, moment.ISO_8601).isSameOrAfter(moment(), 'day');
        const hasPendingRenewal: boolean = this.verifyRenewalProposalStatus(POLICY_STATUS_PENDING_RENEWAL);
        const hasRenewalDeclined: boolean = this.verifyRenewalProposalStatus(POLICY_STATUS_UNDERWRITING_FAILURE);
        const address: any = policy?.insuredRealEstates[0].address;
        let showMissedPaymentBanner: boolean = false;
        const hasOverdueAnnualPayment = annualPolicyInfo != null && +annualPolicyInfo.overdueAnnualInvoiceAmount > 0;
        const inGracePeriod: boolean = annualPolicyInfo != null ? annualPolicyInfo.inGracePeriod : false;
        const hasUnpaidChange = policy.annualPolicyInfo.hasUnpaidChange;

        if (interaction.process === INTERACTION_PROCESS_MTC_LV || interaction.factors.premiumType === AnnualPolicyPremiumTypeEnum.ANNUAL) {
            showMissedPaymentBanner = !!annualPolicyInfo && annualPolicyInfo?.hasDebt;
        }

        return (
            <>
                <SportsVoucherBanner/>
                <DashcamBanner/>
                {hasActivePolicy && <SportsPassBanner/>}
                {hasActivePolicy && <AllianzAdvantagesBanner/>}
                {(!hasActivePolicy || futureCancelledPolicyBeforeInception) && !inGracePeriod &&
                    <NoActivePolicyBanner/>
                }
                {policy && interaction && (!showOverdueInstalmentsBanner || hasOverdueAnnualPayment) && !futureCancelledPolicyBeforeInception && this.showPolicyCancelledBanner() && (
                    <AnnualProductPaymentMessageBanner
                        policyInfo={annualPolicyInfo}
                        showInfoModal={false}
                        interaction={interaction}
                        showMissedPaymentBanner={showMissedPaymentBanner}
                        instalmentsInfo={this.state.missedPaymentInfo ?? this.state.instalmentsInfo}
                        hasRenewalDeclined={false}
                        amount={annualPolicyInfo.overdueAnnualInvoiceAmount}
                    />)}
                {annualPolicyInfo && showOverdueInstalmentsBanner && (
                    <OverdueInstalmentBanner amount={annualPolicyInfo.overdueMonthlyInvoiceAmount}
                                             unpaidInstallmentIdToAmount={annualPolicyInfo.unpaidInstallmentIdToAmount}
                                             policyNumber={interaction.agreementNumber}
                                             product={ProductsEnum.HOME}
                                             reuseCard={this.state.reuseCard}/>
                )}
                {!this.state.renewNextYear && !hasPendingRenewal && !inGracePeriod &&
                    <NextYearAutoRenewalBanner setPerformRenewal={this.setPerformRenewal}
                                                turnOnNextYearRenewal={this.turnOnNextYearRenewal}/>
                }
                {this.state.policy && !!policy?.annualPolicyInfo.unpaidChargebackInvoiceAmount && !outstandingPaid &&
                    <OutstandingPaymentBanner
                        amount={policy.annualPolicyInfo.unpaidChargebackInvoiceAmount}
                        policyNumber={policy.policyNumber}
                        product={policy.interaction.product}
                    />
                }
                {hasPendingRenewal && !inGracePeriod && (this.state.automaticRenewal || this.state.renewNextYear) &&
                    <PolicyWillBeRenewedBanner
                        renewalProposal={this.state.renewalProposal}
                        product="home"
                        productContent={<>{address.addressLine1}, ... {address.postalCode}</>}
                        monthlyInstalmentsAllowed={this.state.renewalProposal?.radarPolicyData?.instalmentAllowedStatus === "A"}
                    />
                }
                {hasPendingRenewal && !inGracePeriod && !this.state.automaticRenewal && !this.state.renewNextYear && policy &&
                    <AutoRenewalInviteBanner
                        renewalProposal={this.state.renewalProposal!}
                        setAutomaticRenewal={this.setAutomaticRenewal}
                        setPerformRenewal={this.setPerformRenewal}
                        showHideWillBeRenewedConfirmation={() => {}} // TODO: looks like this isn't covered as part of FAL-34598
                        monthlyInstalmentsAllowed={this.state.renewalProposal?.radarPolicyData?.instalmentAllowedStatus === "A"}
                        renewalEditUrl={ANNUAL_HOME_RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL}
                        productWording={
                            <>
                                Your home policy for <strong>{address.addressLine1}, ... {address.postalCode} ends on {formatDateTime(policy.endDate)}.</strong>{' '}
                                Until then you're still covered.
                            </>
                        }
                    />
                }
                {hasPendingRenewal && !this.state.automaticRenewal && inGracePeriod &&
                    <GracePeriodBanner
                        renewalProposal={this.state.renewalProposal!}
                        policy={policy}
                        address={address}
                        interaction={interaction}
                    />}
                {hasRenewalDeclined && policy &&
                    <RenewalDeclinedBanner product="home"
                        endDate={policy.endDate}
                        productWording={<>{address.addressLine1}, ... {address.postalCode}</>}
                    />
                }
                {(policy && hasUnpaidChange) &&
                    <UnpaidChangeBanner unpaidChangeDueDate={annualPolicyInfo.unpaidChangeDueDate}
                                        interaction={interaction}/>
                }
            </>
        );
    }

    private renderMtaSuccessPopups(referrerJourney: string | null, showSuccessPopup: string | null, interaction: any, hasPendingRenewal: boolean, policy: any): JSX.Element {
        const instalmentPlan: any = interaction.paymentDetails.instalmentPlan;
        const payFullPrice: boolean = interaction.uistate?.payFullPrice;
        const payUpfrontInterest: boolean = !payFullPrice && instalmentPlan.upfrontInterestCorrectionPayment > 0;
        const upfrontInterestAmount: string = instalmentPlan.upfrontInterestCorrectionPayment;
        const cardEnding: string = interaction.policyHolder.cardDetails?.at(-1)?.number.slice(-4);
        const renewalPrice: any = hasPendingRenewal && interaction.uistate.totalRenewalAmount ? interaction.uistate.totalRenewalAmount : undefined;
        const instalmentsPaidOff: boolean = interaction.factors.premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY && instalmentPlan.totalAmount === 0;
        const paymentsDone: number = this.state.instalmentsInfo?.paymentsDone ?? 0;
        const totalInstalments: number = instalmentPlan.instalments?.length ?? 0;
        const onlyLastInstalmentUnpaid: boolean = paymentsDone === totalInstalments - 1;

        if (referrerJourney === INTERACTION_PROCESS_CHANGE_ADDRESS && showSuccessPopup) {
            return <ChangeAddressStorageSuccessModal
                factors={interaction.factors}
                payFullPrice={payFullPrice}
                cardEnding={cardEnding}
                renewalPrice={renewalPrice}
                instalmentsPaidOff={instalmentsPaidOff}
                onlyLastInstalmentUnpaid={onlyLastInstalmentUnpaid}
            />
        } else if (referrerJourney === INTERACTION_PROCESS_MTA && showSuccessPopup) {
            return <MtaStorageSuccessModal
                factors={interaction.factors}
                payFullPrice={payFullPrice}
                cardEnding={cardEnding}
                payUpfrontInterest={payUpfrontInterest}
                upfrontInterestAmount={upfrontInterestAmount}
                renewalPrice={renewalPrice}
                instalmentsPaidOff={instalmentsPaidOff}
                onlyLastInstalmentUnpaid={onlyLastInstalmentUnpaid}
            />
        } else if (referrerJourney === INTERACTION_PROCESS_RENEWAL && showSuccessPopup) {
            return <GracePeriodRenewalStorageSuccessModal
                policy={policy}
                cardEnding={cardEnding}
            />
        } else {
            return <></>
        }
    }

    private verifyRenewalProposalStatus(checkStatus: string) {
        return this.state.renewalProposal != null && this.state.renewalProposal.status === checkStatus;
    }

    public renderLinkGrid(futureCancelledPolicyBeforeInception: boolean): React.ReactNode {
        const {policy} = this.state;
        const policyCanceled = policy && policy.status === POLICY_STATUS_MTC;
        const policyStarted = policy && moment().isAfter(moment(policy.startDate));
        const activePolicy = policy != null && moment.utc(policy.endDate, moment.ISO_8601).isSameOrAfter(moment(), 'day');
        const isInactiveMTCPolicy = !activePolicy && policyCanceled;
        const hasPendingRenewal: boolean = this.state.renewalProposal != null && this.state.renewalProposal.status === POLICY_STATUS_PENDING_RENEWAL;
        const renewalStatus: string | undefined = hasPendingRenewal ? "Existing" : undefined;
        const claimsLink = this.state.policy?.interaction?.annualHomeFixedAddons?.homeEmergency
            ? `/dashboard/annualHome/${this.props.match.params.policyNumber}/claims/new`
            : `/dashboard/annualHome/${this.props.match.params.policyNumber}/claims/details`;

        const inGracePeriod: boolean = policy?.annualPolicyInfo ? policy.annualPolicyInfo.inGracePeriod : false;
        const allianzAdvantagesEnabled: boolean = this.isAllianzAdvantagesToggleEnabled();

        if (!this.state.policy?.interaction?.annualHomeFixedAddons?.homeEmergency) {
            setSessionStorage("claim", CLAIM_TYPE_OTHER);
        }

        return (
            <div className="link-grid">
                <div className="d-flex flex-wrap">
                    {hasPendingRenewal &&
                        <div className="flexItem pending-renewal">
                            <ImgTileLink src={inGracePeriod ? `/${resourcesHelper.THEME}/img/pending_renewal_gray.svg` : `/${resourcesHelper.THEME}/img/pending_renewal.png`}
                                         alt="Policy renewal icon"
                                         to={ANNUAL_HOME_RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL + this.state.renewalProposal!._id}
                                         status="New"
                                         hasInfoButton={true}
                                         linkDisabled={inGracePeriod}
                                         backButtonName={inGracePeriod ? "Cancel" : "Back"}
                                         infoModalButtonHidden={inGracePeriod}
                                         infoModalTitle="Your renewal, make changes"
                                         infoModalAdditionalDescription={inGracePeriod ? <div className="banner-text banner-warn p-4 mb-3">
                                             <div className="banner-text">
                                                 <p className="font-weight-bold">You are no longer covered</p>
                                                 <p>You must renew your home policy before making changes to your cover</p>
                                                 <Link className="color-cyan-blue"
                                                       to={ANNUAL_HOME_RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL + this.state.renewalProposal!._id}>
                                                     <p className="font-weight-bold hyperlink mt-2 mb-2">
                                                         <img alt="Arrow icon" src={`/${resourcesHelper.THEME}/img/arrow-right.svg`}/>Renew your policy now
                                                     </p>
                                                 </Link>

                                             </div>
                                         </div> : ""}
                                         infoModalBulletPoints={[
                                             "Make changes to your next year home policy (e.g. add a bicycle)",
                                             "Change from annual payment to monthly instalments or vice versa (if instalments are available)",
                                             "Add or remove optional extras (e.g. add Home Legal Expenses)"]}
                                         {...this.props}
                            >
                                Your renewal, make changes
                            </ImgTileLink>
                        </div>
                    }
                    {!futureCancelledPolicyBeforeInception && !isInactiveMTCPolicy &&
                        <div className="flexItem policy-summary">
                            <ImgTileLink
                                src={`/${resourcesHelper.THEME}/img/policy-summary.png`}
                                alt="Policy summary section"
                                to={`/dashboard/annualHome/policySummary/${this.props.match.params.policyNumber}`}
                                hasInfoButton={true}
                                infoModalTitle="Your home policy"
                                infoModalBulletPoints={["View a short breakdown of your home policy"]}
                                status={renewalStatus}
                                {...this.props}
                            >
                                Policy summary
                            </ImgTileLink>
                        </div>
                    }
                    {!inGracePeriod && !policyCanceled && (<div className="flexItem home">
                        <ImgTileLink
                            src={`/${resourcesHelper.THEME}/img/home-icon.png`}
                            alt="Your home, make changes section"
                            to={`/journey/init/product/AnnualHomeInsurance/process/mta/presetPage/${policy?.interaction._id}`}
                            hasInfoButton={true}
                            infoModalTitle="Your home, make changes"
                            infoModalBulletPoints={[
                                "Make changes to your home policy (e.g. property use)",
                                "Add or remove optional extras (e.g. Home Legal expenses)"
                            ]}
                            status={renewalStatus}
                            {...this.props}
                        >
                            Your home, make changes
                        </ImgTileLink>
                    </div>)}
                    <div className="flexItem payment">
                        <ImgTileLink
                            src={`/${resourcesHelper.THEME}/img/payment-card-icon.png`}
                            alt="Payment section"
                            to={`/dashboard/annualPaymentHistory/${this.props.match.params.policyNumber}`}
                            hasInfoButton={true}
                            infoModalTitle="Payment"
                            infoModalBulletPoints={["Change your payment day",
                                "Edit your Direct Debit payment details",
                                "Change your payment card",
                                "Pay off your balance",
                                "View payment history",
                                "Opt in to auto-renew your policy"]}
                            {...this.props}
                        >
                            Payment
                        </ImgTileLink>
                    </div>
                    <div className="flexItem documents">
                        <ImgTileLink
                            src={`/${resourcesHelper.THEME}/img/documents-icon.png`}
                            alt="Documents section"
                            to={`/dashboard/annualHomeDocuments/${this.props.match.params.policyNumber}`}
                            hasInfoButton={true}
                            infoModalTitle="Documents"
                            infoModalBulletPoints={["View your policy documents",
                                "View your old policy documents",
                                "Request documents to be sent by post"]}
                            {...this.props}
                        >
                            Documents
                        </ImgTileLink>
                    </div>
                    {policyStarted && <div className="flexItem make-a-claim">
                        <ImgTileLink
                            src={`/${resourcesHelper.THEME}/img/make-a-claim.png`}
                            alt="Make a claim section"
                            to={claimsLink}
                            hasInfoButton={true}
                            infoModalTitle="Make a claim"
                            infoModalBulletPoints={["Make a contents claim", "Make a buildings claim"]}
                            {...this.props}
                        >
                            Make a claim
                        </ImgTileLink>
                    </div>}
                    <div className="flexItem quotes">
                        <ImgTileLink id="getQuoteTile"
                                     src={`/${resourcesHelper.THEME}/img/savings_icon.png`}
                                     alt="Products icon"
                                     to={`/dashboard/getNewQuote`}
                                     routeState={{
                                         policy,
                                     }}
                                     hasInfoButton={true}
                                     infoModalTitle="Allianz products"
                                     infoModalBulletPoints={
                                         ["View your car or home insurance quote",
                                             "Get a new car or home insurance quote",
                                             "Get a new LV= travel or LV= pet insurance quote"]}
                                     infoModalButton="More about Allianz products"
                                     {...this.props}>
                            Our products
                        </ImgTileLink>
                    </div>
                    {!this.multiPolicyAccount &&
                        <div className="flexItem account-details">
                            <ImgTileLink
                                src={`/${resourcesHelper.THEME}/img/account-details.png`}
                                alt="Account details section"
                                to={`/dashboard/annualHome/account/${this.props.match.params.policyNumber}`}
                                hasInfoButton={true}
                                infoModalTitle="Account details"
                                infoModalBulletPoints={["View and amend account holder details (e.g. email, mobile number, address, password)",
                                    "Opt in to auto-renew your policy"]}
                                {...this.props}
                            >
                                Account details
                            </ImgTileLink>
                        </div>
                    }
                    <div className="flexItem help">
                        <ImgTileLink
                            src={`/${resourcesHelper.THEME}/img/help.png`}
                            alt="Help icon"
                            to={`https://www.allianz.co.uk/insurance/home-insurance/faqs.html`}
                            hasInfoButton={true}
                            infoModalTitle="Help"
                            infoModalBulletPoints={["View 'How to' videos and guides",
                                "Read FAQs about your cover, account, payment, renewal, claims, etc."]}
                            openInNewWindow={true}
                            {...this.props}
                        >
                            Help
                        </ImgTileLink>
                    </div>
                    {!inGracePeriod && !policyCanceled && (<div className="flexItem cancel-policy">
                        {this.getCancellationTile()}
                    </div>)}

                    {activePolicy && !allianzAdvantagesEnabled && !this.multiPolicyAccount && <div className="flexItem savings">
                        <ImgTileLink src={`/${resourcesHelper.THEME}/img/gift_icon.svg`}
                                     alt="Offers icon"
                                     to={`https://www.allianz.co.uk/insurance/car-insurance/customer-offers`}
                                     openInNewWindow={true}
                                     hasInfoButton={true}
                                     infoModalTitle="My offers"
                                     infoModalBulletPointTitle="Our way of saying thanks"
                                     infoModalBulletPoints={["Save with exclusive offers from Allianz"]}
                                     {...this.props}>
                            My offers
                        </ImgTileLink>
                    </div>}

                    {activePolicy && allianzAdvantagesEnabled && <div className="flexItem advantages">
                        <ImgTileLink id="getAdvantagesTile"
                                     src={`/${resourcesHelper.THEME}/img/allianz-star.svg`}
                                     alt="Allianz Advantages icon"
                                     to={`/dashboard/advantages`}
                                     routeState={{
                                         policy,
                                     }}
                                     infoModalBulletPointTitle={`Our way of saying thanks`}
                                     hasInfoButton={true}
                                     infoModalTitle="Allianz Advantages"
                                     infoModalBulletPoints={["Save with exclusive offers from Allianz"]}
                                     infoModalButton="Allianz Advantages"
                                     {...this.props}>
                            Allianz Advantages
                        </ImgTileLink>
                    </div>}
                    {(this.state.hasExpiredPolicies || this.state.hasOldPolicies) && (
                        <div className="flexItem old-policies">
                            <ImgTileLink src={`/${resourcesHelper.THEME}/img/old-policies.png`}
                                         alt="Old policies"
                                         to={this.state.hasOldMotorPolicies ? "/dashboard/annualOldPolicies" : "/dashboard/annualHomeOldPolicies"}
                                         hasInfoButton={true}
                                         infoModalTitle="Old policies"
                                         infoModalBulletPoints={["View your previous policies"]}
                                         {...this.props}>
                                Old policies
                            </ImgTileLink>
                        </div>
                    )}
                    <div className="flexItem marketing-preferences">
                        <ImgTileLink
                            src={`/${resourcesHelper.THEME}/img/exclamation-mark-dark.svg`}
                            alt="Marketing preferences"
                            to={"/dashboard/marketing-preferences"}
                            hasInfoButton={true}
                            infoModalTitle="Marketing preferences"
                            infoModalBulletPoints={["Change your marketing preferences (hear about our latest products, services and discounts)"]}
                            {...this.props}
                        >
                            Marketing preferences
                        </ImgTileLink>
                    </div>
                </div>
            </div>
        )
    }

    private renderSuccessPopup(): React.ReactNode {
        const monthly: boolean = this.state.policy?.interaction?.factors?.premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY
        if (monthly) {
            return (
                <div className="text-center">
                    <p className="mb-0">Thanks for choosing Allianz!</p>
                    <p className="mb-0">Your Direct Debit instruction will be confirmed to you by email within 3 working
                        days or no later than 10 working days before the first collection.</p>
                    <Link className="hyperlink"
                          to={`/dashboard/annualHomeDocuments/${this.props.match.params.policyNumber}`}>Access your
                        documents</Link>
                    <p className="mt-3">
                        <span className="font-weight-bold">Welcome to your Allianz account</span>,
                        transparent, everything online, customize your cover 24/7
                    </p>
                </div>
            )
        }
        return (
            <div className="text-center">
                <p className="mb-0">Thanks for choosing Allianz!</p>
                <Link className="hyperlink" to={`/dashboard/annualHomeDocuments/${this.props.match.params.policyNumber}`}>Access your documents</Link>
                <p className="mt-3">
                    <span className="font-weight-bold">Welcome to your Allianz account</span>,
                    transparent, everything online, customize your cover 24/7
                </p>
            </div>
        )
    }

    private getCancellationTile(): React.ReactNode {
        if (this.state.renewalProposal && this.state.renewNextYear) {
            return (
                <ImgTileLink
                    src={`/${resourcesHelper.THEME}/img/cancel-policy-icon.png`}
                    alt="Cancel policy section"
                    to={`/dashboard/home/cancel/${this.props.match.params.policyNumber}`}
                    routeState={{
                        mtcJourneyUrl: `/journey/init/product/AnnualHomeInsurance/process/mtc/presetPage/${this.state.policy?.interaction?._id}`,
                        renewalCancellationUrl: `/journey/show/product/AnnualHomeInsurance/process/renewal/cancellationPresetPage/${this.state.renewalProposal._id}`,
                        pageTitle: "Cancel home policy",
                        questionTitle: "When would you like your home policy to end?"
                    }}
                    hasInfoButton={true}
                    infoModalTitle="Cancel policy"
                    infoModalBulletPoints={["Cancel your policy"]}
                    {...this.props}
                >
                    Cancel policy
                </ImgTileLink>
            )
        } else {
            return (
                <ImgTileLink
                    src={`/${resourcesHelper.THEME}/img/cancel-policy-icon.png`}
                    alt="Cancel policy section"
                    to={`/journey/init/product/AnnualHomeInsurance/process/mtc/presetPage/${this.state.policy?.interaction?._id}`}
                    hasInfoButton={true}
                    infoModalTitle="Cancel policy"
                    infoModalBulletPoints={["Cancel your policy"]}
                    {...this.props}
                >
                    Cancel policy
                </ImgTileLink>
            )
        }
    }

    private setPerformRenewal(value: boolean): void {
        this.setState({
            apiCalled: true
        });

        this.customerPortalService.storePolicyPerformRenewalFlag(this.props.match.params.policyNumber, value)
            .subscribe(() => {
                    this.setState({
                        automaticRenewal: value,
                        renewNextYear: value,
                        apiCalled: false
                    })
                }
            )
    }

    private setAutomaticRenewal(value: boolean): void {
        this.setState({
            apiCalled: true
        });

        this.customerPortalService.storePolicyPerformRenewalFlag(this.props.match.params.policyNumber, value)
            .subscribe(() => {
                    this.setState({
                        renewNextYear: value,
                        apiCalled: false
                    })
                }
            )
    }

    private turnOnNextYearRenewal(): void {
        this.setPerformRenewal(true);
        this.setState({
            showRenewalSwitchConfirmation: true
        })
    }

    private turnOnManualNextYearRenewal(): void {
        this.setPerformRenewal(true);
        window.sessionStorage.setItem("manualRenewalPopUpIsShown", "true")
        this.setState({
            showManualRenewalConfirmation: true
        })
    }

    private hideManualRenewalConfirmation(): void {
        this.setState({
            showManualRenewalConfirmation: false
        })
    }

    private displayReviewDialog() {
        const createRevPromises: Array<Promise<any>> = [];
        createRevPromises.push(this.customerPortalService.createReviewRequest(this.props.match.params.policyNumber).toPromise());
    }

    private showPolicyCancelledBanner(): boolean {
        const endDate: any = moment.utc(this.state.policy?.interaction.headerInfo.endDate, moment.ISO_8601);
        return (!this.state.bannerShownLocally || this.state.bannerShownInSession || !endDate.isBefore(moment(), 'day'));
    }

    private filterByProduct(policies: Policy[], product: ProductsEnum): Policy[] {
        return policies.filter(p => p.products.includes(product));
    }

    private isAllianzAdvantagesToggleEnabled() {
        return process.env.REACT_APP_ALLIANZ_ADVANTAGES_ENABLED ? JSON.parse(process.env.REACT_APP_ALLIANZ_ADVANTAGES_ENABLED) : false;
    }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/annual/home/AnnualHomeDashboardPage.tsx